<aside
  id="qr-code-login-component">
  <!-- Spinner while camera is loading in QR scanner or QR login is processing. Specific to Student login. -->
  @if (showStudentQrCodeSpinner) {
    <div #preloader>
      <div class="preloader spinner">
        <zbp-preloader></zbp-preloader>
      </div>
    </div>
  }

  <!-- Hide separator while camera is scanning -->
  @if ((isQrScannerRunning$ | async) === false) {
    <div class="text-uppercase or-separator mobile-only-separator">OR</div>
    <!-- Hide QR Example while camera is scanning -->
    <img alt="QR code example" src="assets/img/qr-code-with-camera.png" class="qr-code-example-image" />

    <!-- Hide Login with QR Code button while camera is scanning -->
    <zbp-button-component
      id="loginWithQRCodeButton"
      type="button"
      theme="ghost"
      iconName="camera"
      iconSize="font-size"
      label="Login with QR Code"
      (clickHandler)="prepQrCodeScan()"
      >
    </zbp-button-component>
  }

  <!-- Scanner for QR code -->
  <h1 class="sr-only">Scan QR Code to Login</h1>
  @if (isQrScannerRunning$ | async) {
    <div id="qrCodeScanner" style="width: 400px; height: auto; margin: 0 25%; box-shadow: 0 0 5px 0 rgba(45, 0, 53, 0.25);"></div>
  }
  <!-- Show Cancel button after the QR code scanner is loaded and while login isn't processing.  -->
  @if ((isQrScannerRunning$ | async) && !showStudentQrCodeSpinner) {
    <div class="py-2">
      <zbp-button-component
        id="cancelScan"
        (clickHandler)="cancelQrCodeScan(true)"
        theme="primary"
        label="Cancel"
      ></zbp-button-component>
    </div>
  }

  <!-- Hide support link while camera is scanning -->
  @if ((isQrScannerRunning$ | async) === false) {
    <a [href]="supportLinks.qrCodeLoginHelpVideo" target="_blank" class="text-link login-help-link">Need help scanning your QR Code?</a>
  }
</aside>